<script>
import options from './SiteNavigationMobile.options'
export default options
</script>

<template>
    <nav class="nlx-site-navigation-mobile">
        <ul class="nlx-site-navigation-mobile__main-menu-links">
            <template v-for="(group, index, key) in menudata" :key="index">
                <li>
                    <button class="nlx-site-navigation-mobile__link-group-toggle" @click="toggleGroup(index)">{{group.displayName}}</button>
                    <ul v-show="groupsVisible[index]" class="nlx-site-navigation-mobile__link-group">
                    <template v-for="(megamenu,megaindex) in group.megaMenu" :key="megaindex">
                        <template v-for="(item,itemindex) in megamenu" :key="itemindex">
                            <li>
                                <template v-if="itemindex === 0">
                                        <span class="nlx-site-navigation-mobile__sub-group-name">{{item.displayName}}</span> 
                                        <button class="nlx-site-navigation-mobile__sub-group-toggle" :class="{'nlx-site-navigation-mobile__sub-group-toggle--open':sublevelsVisible[index+megaindex]}" @click="toggleSublevel(index+megaindex)">
                                            <span>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#000000" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg>
                                            </span>
                                        </button>
                                    
                                </template>
                                <template v-else>
                                    <ul class="nlx-site-navigation-mobile__sub-level" v-show="sublevelsVisible[index+megaindex]">
                                    <template v-for="(sub,subindex) in item" :key="subindex">
                                        <li><a class="nlx-site-navigation-mobile__sub-group-link" :href="sub.href">{{sub.displayName}}</a></li>
                                    </template>
                                    </ul>
                                </template>
                            </li>
                        </template>
                    </template>
                    </ul>
                </li>
            </template>
        </ul>

        <ul class="nlx-site-navigation-mobile__service-menu-links">
            <template v-for="(link,index) in serviceMenuData" :key="index">
                <li><a :href="link.href">{{link.displayName}}</a></li>
            </template>
        </ul>

        <section class="nlx-site-navigation-mobile__country-selector-container">
            <ul v-show="langSelectorVisible" class="nlx-site-navigation-mobile__country-selector">
                <template v-for="(link,index) in countrySelectorData" :key="index">
                    <li><a :href="link.href">{{link.displayName}}</a></li>
                </template>
            </ul>
            <button @click="toggleCountrySelector" class="nlx-site-navigation-mobile__country-selector-button">
                {{activeLang}}
                <span class="nlx-site-navigation-mobile__country-selector-chevron">
                    <template v-if="langSelectorVisible">-</template>
                    <template v-else>+</template>
                </span>
            </button>
        </section>
        

        <PriceToggle class="nlx-price-toggle--mobile" />
    </nav>
</template>